<script setup lang="ts">
/**
 * CaCard — permukaan dasar. Aturan elevasi design system:
 * STRUKTUR pakai border 1px, BUKAN shadow. Shadow hanya untuk yang melayang.
 * Radius 16px (naik dari 10px versi lama), padding 20px mobile / 24px desktop.
 */
withDefaults(
  defineProps<{
    /**
     * `plain` = permukaan biasa, `soft` = latar redup, `brand` = ditonjolkan (border tebal),
     * `emas` = sorotan tema v3 (latar gold sangat lembut + border gold).
     */
    tone?: 'plain' | 'soft' | 'brand' | 'emas'
    /** Matikan padding kalau isi kartu perlu menempel tepi (mis. tabel). */
    flush?: boolean
    /**
     * Kartu yang seluruhnya bisa diklik. Hanya transform + shadow yang dianimasi
     * (bukan border/warna) supaya tidak memicu repaint mahal di GPU HP kelas bawah.
     */
    interaktif?: boolean
  }>(),
  { tone: 'plain' }
)
</script>

<template>
  <div
    class="rounded-card"
    :class="[
      tone === 'soft' ? 'bg-surface-2 border border-line' : '',
      tone === 'plain' ? 'bg-surface border border-line' : '',
      tone === 'brand' ? 'bg-surface border-2 border-brand' : '',
      tone === 'emas' ? 'bg-brand-soft border border-brand/35' : '',
      flush ? '' : 'p-5 sm:p-6',
      interaktif
        ? 'transition-[transform,box-shadow] duration-[120ms] ease-[cubic-bezier(0.2,0,0,1)] hover:-translate-y-0.5 hover:shadow-float'
        : ''
    ]"
  >
    <slot />
  </div>
</template>
